import jQueryBridget from 'jquery-bridget'
import Flickity from 'flickity'

export default {
  init() {
    // JavaScript to be fired on the home page
    // Fullscreen Flickity Carousel on demand from gallery images
    var focus = Flickity.prototype.focus;
    Flickity.prototype.focus = function () {
      // use non-standard setActive for IE11. #651
      if (this.element.setActive) {
        this.element.setActive();
        return;
      }
      // use default
      focus.apply(this, arguments);
    };

    Flickity.setJQuery($);
    jQueryBridget('flickity', Flickity, $);

    $('.home-gallery').flickity({
      wrapAround: true,
      pageDots: false,
      autoPlay: 8000,
      // setGallerySize: true,
      prevNextButtons: true,
    });
  },
  finalize() {
    // JavaScript to be fired on the home page, after the init JS
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/home.js